import React from 'react'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'

function index() {
  return (
    <div>
      <SubPageBreadCrumbs />
      Fianace</div>
  )
}

export default index